import React from 'react';
import { useNavigate } from 'react-router-dom';

const IBGrading: React.FC = () => {
  const navigate = useNavigate();

  // 로고 클릭 처리
  const handleLogoClick = () => {
    navigate('/');
  };

  // 섹션으로 스크롤 이동
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  // 다운로드 파일 데이터
  const downloadFiles = [
    {
      title: 'IB 성적처리 파일',
      description: 'IB 성적처리 파일 다운로드 하기기',
      version: 'v1.1',
      date: '2025.10.12',
      fileUrl: 'https://1drv.ms/u/c/f326a53b9af299ff/EdTZovYSCKBJrRW7GfynbgMBj8Ls-CnJ-TMDbdCa_Lte-g?e=7YUctU',
      icon: '📁'
    }
  ];

  // 사용 가이드 데이터
  const guideSteps = [
    {
      step: '1',
      title: '압축파일 다운로드',
      description: '아래의 IB 성적처리 파일을 다운받아 주세요.'
    },
    {
      step: '2',
      title: '학생 정보 입력',
      description: '엑셀 파일에 학생 정보와 평가 점수를 입력합니다.'
    },
    {
      step: '3',
      title: '자동 계산 확인',
      description: '입력된 점수가 IB 기준에 맞게 자동으로 계산됩니다.'
    },
    {
      step: '4',
      title: '성적표 출력',
      description: '완성된 성적 데이터를 학생별 성적표로 출력합니다.'
    }
  ];

  // 사용법 안내 카드 데이터
  const guideMenus = [
    {
      title: '교과군별 평가기준 성취수준 집계표',
      description: '교과군별 평가기준 성취수준 집계표 작성 방법을 단계별로 안내합니다.',
      route: '/ib-grading/subject-group-guide',
      icon: '📊',
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    },
    {
      title: '학년 말 전체 성적표',
      description: '학년 말 전체 성적표 작성 방법을 단계별로 안내합니다.',
      route: '/ib-grading/final-grade-guide',
      icon: '📝',
      color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
    }
  ];

  // 파일 다운로드 처리
  const handleDownload = (fileUrl: string, fileName: string) => {
    // 외부 링크인 경우 새 탭에서 열기
    if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) {
      window.open(fileUrl, '_blank');
    } else {
      // 내부 파일인 경우 알림 표시
      alert(`${fileName} 다운로드가 시작됩니다.\n(실제 파일은 서버에 업로드가 필요합니다)`);
    }
  };


  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      background: 'white',
      position: 'relative'
    }}>
      {/* 메인 컨텐츠 영역 */}
      <main style={{
        width: '100%',
        paddingTop: '0',
        position: 'relative'
      }}>
        {/* 히어로 섹션 */}
        <div style={{
          width: '100%',
          height: '400px',
          position: 'relative',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            maxWidth: '1280px',
            width: '100%',
            paddingLeft: '80px',
            paddingRight: '80px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '24px',
            display: 'flex',
            zIndex: 10
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <div style={{
                color: 'white',
                fontSize: '48px',
                fontFamily: 'pretendard',
                fontWeight: '700',
                lineHeight: '72px'
              }}>
                서울시교육청 IB 성적처리 시스템 파일 배포 페이지 
              </div>
              <div style={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: '20px',
                fontFamily: 'pretendard',
                fontWeight: '400',
                lineHeight: '30px'
              }}>
                서울시교육청 산하 학교의 성적 처리를 위한 공식 템플릿과 도구를 제공합니다.
              </div>
            </div>
          </div>
        </div>

        {/* 사용 가이드 섹션 */}
        <div 
          id="guide-section"
          style={{
            width: '100%',
            paddingTop: '80px',
            scrollMarginTop: '80px',
            display: 'flex',
            justifyContent: 'center'
          }}>
          <div style={{
            maxWidth: '1280px',
            width: '100%',
            paddingLeft: '80px',
            paddingRight: '80px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '40px'
          }}>
            {/* 섹션 타이틀 */}
            <div style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: '8px',
              display: 'flex'
            }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-normal, #161616)',
              fontSize: '36px',
              fontFamily: 'pretendard',
              fontWeight: '600',
              lineHeight: '54px'
            }}>
              사용 가이드
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-assistive-strong, #4C4C4C)',
              fontSize: '16px',
              fontFamily: 'pretendard',
              fontWeight: '400',
              lineHeight: '24px'
            }}>
              간단한 4단계로 IB 성적을 처리할 수 있습니다.
            </div>
          </div>

          {/* 가이드 스텝 */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: '24px'
          }}>
            {guideSteps.map((guide, index) => (
              <div 
                key={index}
                style={{
                  width: '302px',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  gap: '16px',
                  display: 'inline-flex'
                }}
              >
                {/* 스텝 번호 */}
                <div style={{
                  width: '60px',
                  height: '60px',
                  background: 'var(--Color-fill-brand-color, #FF6F0F)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '28px',
                  fontFamily: 'pretendard',
                  fontWeight: '700'
                }}>
                  {guide.step}
                </div>
                
                {/* 스텝 내용 */}
                <div style={{
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  gap: '8px',
                  display: 'flex'
                }}>
                  <div style={{
                    color: 'var(--Color-text-normal, #161616)',
                    fontSize: '20px',
                    fontFamily: 'pretendard',
                    fontWeight: '600',
                    lineHeight: '30px'
                  }}>
                    {guide.title}
                  </div>
                  <div style={{
                    color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                    fontSize: '14px',
                    fontFamily: 'pretendard',
                    fontWeight: '400',
                    lineHeight: '21px'
                  }}>
                    {guide.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
          </div>
        </div>

        {/* 상세 사용법 선택 섹션 */}
        <div style={{
          width: '100%',
          paddingTop: '80px',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <div style={{
            maxWidth: '1280px',
            width: '100%',
            paddingLeft: '80px',
            paddingRight: '80px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '40px'
          }}>
            {/* 섹션 타이틀 */}
            <div style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: '8px',
              display: 'flex'
            }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-normal, #161616)',
              fontSize: '36px',
              fontFamily: 'pretendard',
              fontWeight: '600',
              lineHeight: '54px'
            }}>
              상세 사용법
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-assistive-strong, #4C4C4C)',
              fontSize: '16px',
              fontFamily: 'pretendard',
              fontWeight: '400',
              lineHeight: '24px'
            }}>
              원하시는 기능의 상세 사용법을 선택해주세요.
            </div>
          </div>

          {/* 사용법 메뉴 카드 */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '24px',
            width: '100%'
          }}>
            {guideMenus.map((menu, index) => (
              <div 
                key={index}
                style={{
                  width: '100%',
                  minHeight: '280px',
                  padding: '40px',
                  background: menu.color,
                  borderRadius: '16px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}
                onClick={() => navigate(menu.route)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                }}
              >
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px'
                }}>
                  {/* 아이콘 */}
                  <div style={{
                    fontSize: '48px',
                    lineHeight: '1'
                  }}>
                    {menu.icon}
                  </div>
                  
                  {/* 제목 */}
                  <div style={{
                    color: 'white',
                    fontSize: '24px',
                    fontFamily: 'pretendard',
                    fontWeight: '700',
                    lineHeight: '36px'
                  }}>
                    {menu.title}
                  </div>
                  
                  {/* 설명 */}
                  <div style={{
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontSize: '16px',
                    fontFamily: 'pretendard',
                    fontWeight: '400',
                    lineHeight: '24px'
                  }}>
                    {menu.description}
                  </div>
                </div>
                
                {/* 이동 버튼 */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  gap: '8px',
                  marginTop: '24px'
                }}>
                  <div style={{
                    color: 'white',
                    fontSize: '16px',
                    fontFamily: 'pretendard',
                    fontWeight: '600',
                    lineHeight: '24px'
                  }}>
                    자세히 보기
                  </div>
                  <div style={{
                    fontSize: '20px',
                    lineHeight: '1'
                  }}>
                    →
                  </div>
                </div>
              </div>
            ))}
          </div>
          </div>
        </div>

        {/* 다운로드 파일 섹션 */}
        <div 
          id="download-section"
          style={{
            width: '100%',
            paddingTop: '120px',
            scrollMarginTop: '80px',
            display: 'flex',
            justifyContent: 'center'
          }}>
          <div style={{
            maxWidth: '1280px',
            width: '100%',
            paddingLeft: '80px',
            paddingRight: '80px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '40px'
          }}>
            {/* 섹션 타이틀 */}
            <div style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: '8px',
              display: 'flex'
            }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-normal, #161616)',
              fontSize: '36px',
              fontFamily: 'pretendard',
              fontWeight: '600',
              lineHeight: '54px'
            }}>
              다운로드 파일
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-assistive-strong, #4C4C4C)',
              fontSize: '16px',
              fontFamily: 'pretendard',
              fontWeight: '400',
              lineHeight: '24px'
            }}>
              필요한 파일을 선택하여 다운로드하세요.
            </div>
          </div>

          {/* 파일 카드 그리드 */}
          <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '24px',
            flexWrap: 'wrap'
          }}>
            {downloadFiles.map((file, index) => (
              <div 
                key={index}
                style={{
                  width: '628px',
                  height: '180px',
                  padding: '32px',
                  background: 'var(--Color-background-sub, #F8F8F8)',
                  borderRadius: '12px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  border: '2px solid transparent'
                }}
                onClick={() => handleDownload(file.fileUrl, file.title)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.1)';
                  e.currentTarget.style.borderColor = 'var(--Color-fill-brand-color, #FF6F0F)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = 'transparent';
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '24px'
                }}>
                  {/* 아이콘 */}
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'var(--Color-fill-white, white)',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '40px'
                  }}>
                    {file.icon}
                  </div>
                  
                  {/* 파일 정보 */}
                  <div style={{
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: '8px',
                    display: 'flex'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px'
                    }}>
                      <div style={{
                        color: 'var(--Color-text-normal, #161616)',
                        fontSize: '20px',
                        fontFamily: 'pretendard',
                        fontWeight: '600',
                        lineHeight: '30px'
                      }}>
                        {file.title}
                      </div>
                      <div style={{
                        padding: '2px 8px',
                        background: 'var(--Color-fill-brand-color, #FF6F0F)',
                        borderRadius: '4px',
                        color: 'white',
                        fontSize: '12px',
                        fontFamily: 'pretendard',
                        fontWeight: '500'
                      }}>
                        {file.version}
                      </div>
                    </div>
                    <div style={{
                      color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                      fontSize: '14px',
                      fontFamily: 'pretendard',
                      fontWeight: '400',
                      lineHeight: '21px'
                    }}>
                      {file.description}
                    </div>
                    <div style={{
                      color: 'var(--Color-text-assistive, #989898)',
                      fontSize: '12px',
                      fontFamily: 'pretendard',
                      fontWeight: '400',
                      lineHeight: '18px'
                    }}>
                      업데이트: {file.date}
                    </div>
                  </div>
                </div>
                
                {/* 다운로드 아이콘 */}
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: 'var(--Color-fill-brand-color, #FF6F0F)',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '20px'
                }}>
                  ⬇️
                </div>
              </div>
            ))}
          </div>
          </div>
        </div>

        {/* 주의사항 섹션 */}
        <div style={{
          width: '100%',
          paddingTop: '120px',
          paddingBottom: '80px',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <div style={{
            maxWidth: '1280px',
            width: '100%',
            paddingLeft: '80px',
            paddingRight: '80px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '24px'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              color: 'var(--Color-text-normal, #161616)',
              fontSize: '28px',
              fontFamily: 'pretendard',
              fontWeight: '600',
              lineHeight: '42px'
            }}>
              ⚠️ 주의사항
            </div>
          
          <div style={{
            padding: '32px',
            background: 'var(--Color-background-sub, #F8F8F8)',
            borderRadius: '12px',
            borderLeft: '4px solid var(--Color-fill-brand-color, #FF6F0F)'
          }}>
            <ul style={{
              margin: 0,
              paddingLeft: '20px',
              color: 'var(--Color-text-assistive-strong, #4C4C4C)',
              fontSize: '16px',
              fontFamily: 'pretendard',
              fontWeight: '400',
              lineHeight: '28px'
            }}>
              <li>본 파일의 저작권과 모든 권리는 서울특별시교육청에 있으며, 서울시교육청 산하 IB학교 교사의 편의를 위해 제작되었습니다.</li>
              <li>무단 배포 및 임의 가공은 금지되어 있으며, 타 시도에서 사용이나 2차 가공을 원하실 경우 반드시 서울특별시교육청에 문의하시기 바랍니다.</li>
              <li>본 프로그램은 <b>Office 365</b> 버전을 기준으로 작성되었으며, 이전 버전 Office를 사용하는 경우 제대로 작동하지 않을 수 있습니다.</li>
              <li>수정이나 기타 문의 사항은 jihotech16@outlook.kr (교사 한지호)로 연락주십시오.</li>
            </ul>
          </div>
          </div>
        </div>

        {/* 문의 섹션 */}
        <div 
          id="contact-section"
          style={{
            width: '100%',
            paddingBottom: '80px',
            scrollMarginTop: '80px',
            display: 'flex',
            justifyContent: 'center'
          }}>
          <div style={{
            maxWidth: '1280px',
            width: '100%',
            paddingLeft: '80px',
            paddingRight: '80px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '24px'
          }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: 'var(--Color-text-normal, #161616)',
            fontSize: '36px',
            fontFamily: 'pretendard',
            fontWeight: '600',
            lineHeight: '54px'
          }}>
            문의하기
          </div>
          
          <div style={{
            width: '100%',
            maxWidth: '800px',
            padding: '40px',
            background: 'var(--Color-background-sub, #F8F8F8)',
            borderRadius: '12px',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px'
            }}>
              <div style={{
                fontSize: '24px'
              }}>
                📧
              </div>
              <div>
                <div style={{
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '18px',
                  fontFamily: 'pretendard',
                  fontWeight: '600',
                  lineHeight: '27px',
                  marginBottom: '4px'
                }}>
                  이메일 문의
                </div>
                <div style={{
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                  fontSize: '16px',
                  fontFamily: 'pretendard',
                  fontWeight: '400',
                  lineHeight: '24px'
                }}>
                  jihotech16@outlook.kr (교사 한지호)
                </div>
              </div>
            </div>

            <div style={{
              height: '1px',
              background: 'var(--Color-line-normal, #F0F0F0)'
            }} />

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px'
            }}>
              <div style={{
                fontSize: '24px'
              }}>
                🏫
              </div>
              <div>
                <div style={{
                  color: 'var(--Color-text-normal, #161616)',
                  fontSize: '18px',
                  fontFamily: 'pretendard',
                  fontWeight: '600',
                  lineHeight: '27px',
                  marginBottom: '4px'
                }}>
                  저작권 및 사용 문의
                </div>
                <div style={{
                  color: 'var(--Color-text-assistive-strong, #4C4C4C)',
                  fontSize: '16px',
                  fontFamily: 'pretendard',
                  fontWeight: '400',
                  lineHeight: '24px'
                }}>
                  서울특별시교육청
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          width: '100%',
          height: '120px',
          padding: '32px 80px',
          background: 'var(--Color-fill-normal, #293044)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div style={{
            textAlign: 'center',
            color: 'var(--Color-text-assistive, #989898)',
            fontSize: '14px',
            fontFamily: 'pretendard',
            fontWeight: '400',
            lineHeight: '21px'
          }}>
            서울시교육청 IB 성적처리 시스템 | 문의: jihotech16@outlook.kr (교사 한지호)<br />
            @Maru Corp. All rights reserved.
          </div>
        </div>
      </main>
    </div>
  );
};

export default IBGrading;

